import API          from '../../../../../common/http/api.fetch';
import {success, responseMessage}
                    from '../../../../../common/utils/util.notifier';
import I18N         from '../../../../../common/utils/util.i18n';
import { TYPES }    from '../../audit-action-type.constants';
import { IDS }      from '../../audit-action-id.constants';
import pick         from 'lodash/pick';

export const updateRequirementAudit = (asa_id, due_date, auditors) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/update-requirement-audit`,
            method: 'PUT',
            data: {
                asa_id,
                due_date,
                auditors,
            }
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
        },error => {
            responseMessage(error)
        });
    };
};

export const addEvidenceProvider = (item) => {
    return dispatch => {
        return dispatch({
            type: TYPES.ADD_AUDIT_ASSIGNEE,
            id: IDS.accAudit,
            path: 'details.evidenceProviders',
            item
        });
    };
};
